export const draftFrCATranslations = {
  draftBannerMessage:
    "Vous avez des modifications non enregistrées d'une session précédente.",
  draftBannerRestore: "Restaurer",
  draftBannerDiscard: "Supprimer",
  clearDraftTooltip: "Effacer le formulaire",
};
